<bcp-navbar theme="dark" brand-logo="/assets/img/logos/bcp-dark-default.svg" fluid>
    <div slot="content-right" class="d-flex" >
      <bcp-paragraph data-testid="remaining-time" size="md" family="regular" color="white" *ngIf="secondsRemaining && this.biometricService.initTime()">{{ secondsRemaining }} SEGUNDOS</bcp-paragraph>
      <bcp-icon name="chronometer-r" color="white" size="16" style="padding: 2px 0px 0px 4px; "  *ngIf="secondsRemaining && this.biometricService.initTime()"></bcp-icon>
    </div>
</bcp-navbar>